export default __webpack_public_path__ + "static/media/chartBackIcon.d5c1cd3b.svg";